export default __webpack_public_path__ + "static/media/kycPayment.8d2a96cd.svg";